import { FC } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';

import { CustomerForNotification } from 'types/customer';
import { ReadonlyCustomerList } from './ReadonlyCustomerList';

type Props = {
  mode: '新規作成' | '更新';
  isOpen: boolean;
  title: string;
  message: string;
  isHigh: boolean;
  startDate: string;
  endDate: string;
  conditionForDisplay: string;
  shouldShowCustomerList: boolean;
  selectedCustomers: CustomerForNotification[];
  selectedCustomersLength: number;
  handleClose: () => void;
  handleClickGoInput: () => void;
  handleClickExecution: () => void;
};

export const ConfirmationModalView: FC<Props> = ({
  mode,
  isOpen,
  title,
  message,
  isHigh,
  startDate,
  endDate,
  conditionForDisplay,
  shouldShowCustomerList,
  selectedCustomers,
  selectedCustomersLength,
  handleClose,
  handleClickGoInput,
  handleClickExecution,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="6xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    <ModalContent h="90vh">
      <ModalHeader p="40px 40px 0 40px">お知らせ{mode}</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        <Box mt="40px">
          <Heading as="h5" size="sm">
            タイトル
          </Heading>
          <Text fontSize="md">{title}</Text>
        </Box>
        <Box mt="40px">
          <Heading as="h5" size="sm">
            本文
          </Heading>
          <Text fontSize="md" whiteSpace="pre-wrap">
            {message}
          </Text>
        </Box>
        <Box mt="40px">
          <Heading as="h5" size="sm">
            お知らせ種別
          </Heading>
          <Checkbox isChecked={isHigh} colorScheme="gray" disabled>
            重要なお知らせ
          </Checkbox>
        </Box>
        <Box mt="40px">
          <Heading as="h5" size="sm">
            表示期間
          </Heading>
          <Text fontSize="md">
            {startDate} ~ {endDate}
          </Text>
        </Box>
        <Box mt="40px">
          <Heading as="h5" size="sm">
            配信対象顧客
          </Heading>
          <Text fontSize="md">{conditionForDisplay}</Text>
        </Box>
        <Box mt="40px">
          {shouldShowCustomerList && (
            <ReadonlyCustomerList
              selectedCustomers={selectedCustomers}
              selectedCustomersLength={selectedCustomersLength}
            />
          )}
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" mt="20px" mb="20px">
        <VStack>
          <Text fontSize="lg" textAlign="center">
            上記の内容でお知らせを{mode}しますか？
          </Text>
          <Box h="20px" />
          <HStack>
            <Button
              colorScheme="gray"
              variant="outline"
              mr={3}
              onClick={handleClickGoInput}
            >
              入力画面へ戻る
            </Button>

            <Button
              width="140px"
              colorScheme="blackAlpha"
              mr={3}
              onClick={handleClickExecution}
            >
              {mode}
            </Button>
          </HStack>
        </VStack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
